// extracted by mini-css-extract-plugin
module.exports = {"container":"RetexDetails_container__2zl7W","row":"RetexDetails_row__AyPX6"};